module.exports = __webpack_public_path__ + "img/arrow-down.4e8b849c.svg";